<template>
  <div class="filer-price">
    <div class="filer-price-value">
      <p>{{ displayCustomPrice(value[0]) }}</p>
      <p>{{ displayCustomPrice(value[1]) }}</p>
    </div>

    <Slider
      :value="value"
      :min="minPrice"
      :max="maxPrice"
      :step="1"
      :range="true"
      :formatter="formatter"
      @change="updateValue"
      @slide="updateValues"
    />
    <p style="width: 20vw"> </p>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Slider from '@vueform/slider';
import '@vueform/slider/themes/default.css';
const emit = defineEmits(["setRangerPrice", 'resetComplete']);
const value = ref([0, 0]);

const props = defineProps({
  minPrice: Number,
  maxPrice: Number,
  reset: Boolean,
  currentPrice:Object
});


onMounted(() => {

      if (props.currentPrice[1] > 0) {
       value.value = [parseInt(props.currentPrice[0]), parseInt(props.currentPrice[1])]
  }
  value.value = [parseInt(props.minPrice), parseInt(props.maxPrice)]
});

watch(() => props.reset, (newValue) => {
  if (newValue) {
    value.value = [parseInt(props.minPrice), parseInt(props.maxPrice)]
    emit('resetComplete')
  }
})

watch(() => props.minPrice, (newValue) => {
  value.value = [parseInt(props.minPrice), parseInt(props.maxPrice)]
}, { immediate: true });

watch(() => props.currentPrice, (newValue) => {
  if (newValue) {
  if(newValue[1] > 0){
    value.value = [parseInt(props.currentPrice[0]), parseInt(props.currentPrice[1])]
  }

  }
}, { immediate: true });
const formatter = (val) => {
  return `${val}$`;
};
const updateValues = (val) => {
  value.value = val;
}
const updateValue = (newValue) => {
  emit('setRangerPrice',newValue)
};
</script>
